import { parseISO, format } from "date-fns";

/**
 * Converts an ISO timestamp into a readable date/time string in the user's local time.
 *
 * @param {string} isoString - The ISO-8601 timestamp.
 * @returns {string} Local date/time string, or "" if invalid.
 */
export function formatTimestamp(isoString) {
  if (!isoString) return "";

  try {
    const date = parseISO(isoString);
    return format(date, "M/d/yyyy, h:mm:ss a");
  } catch (error) {
    return "";
  }
}
